import React, { useEffect, useState } from 'react';
import { useContracts } from '../../hooks/useContracts';

const TeamHeader = ({ userId, sponsorId }) => {
  const { coreStorage } = useContracts();
  const [directs, setDirects] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!coreStorage?.read || !userId) {
        setDirects([]);
        return;
      }
      setLoading(true);
      try {
        const ids = await coreStorage.read.getUserReferrals(userId);
        if (!cancelled) setDirects(ids.map((x) => x.toString()));
      } catch {
        if (!cancelled) setDirects([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [coreStorage, userId]);

  return (
    <div className="grid grid-2" style={{ marginBottom: 18 }}>
      {/* Upline */}
      <div className="card">
        <div className="card-title">Your Upline</div>
        {sponsorId && sponsorId !== '0' ? (
          <>
            <div className="card-value yellow" style={{ marginTop: 4 }}>#{sponsorId}</div>
            <div className="card-sub">The sponsor who registered you</div>
          </>
        ) : (
          <>
            <div className="card-value" style={{ marginTop: 4 }}>—</div>
            <div className="card-sub">No upline (default referrer)</div>
          </>
        )}
      </div>

      {/* Directs */}
      <div className="card">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className="card-title" style={{ marginBottom: 0 }}>Direct Referrals</div>
          <span className="badge badge-green">{loading ? '…' : directs.length}</span>
        </div>

        {loading ? (
          <div className="card-sub" style={{ marginTop: 10 }}>Loading…</div>
        ) : directs.length === 0 ? (
          <div className="empty" style={{ padding: '14px 0 4px' }}>
            <div className="empty-title">No direct referrals yet</div>
            <div className="card-sub" style={{ marginTop: 4 }}>Share your referral link to invite users</div>
          </div>
        ) : (
          <div className="lvl-chips" style={{ marginTop: 10 }}>
            {directs.map((id) => (
              <span key={id} className="lvl-chip">#{id}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamHeader;
